/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styles for the assignment due date field.
 *
 * @file assignmentDueDateFieldStyles.js
 * @author Anuja Gaikwad
 * @since 2.0.0
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';
import { createScopedClasses, createScopedStyles } from '../../../assets/styles/createScopedStyles';
import {
  getAssignmentDueDateCalendarHeaderStyles,
  getAssignmentDueDateCalendarStyles
} from './assignmentDueDateCalendarStyles';

const calendarHeaderStyles = getAssignmentDueDateCalendarHeaderStyles();

const assignmentDueDateFieldStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    maxWidth: 450,
    minWidth: 0
  },
  inputRow: {
    position: 'relative',
    width: '100%',
    height: 50
  },
  input: {
    width: '100%',
    height: 50,
    boxSizing: 'border-box',
    borderRadius: 4,
    padding: '12px 40px 12px 12px',
    backgroundColor: mixins.chalkWhiteFont,
    border: `1px solid ${mixins.amethystColorV2}`,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    fontFamily: mixins.fontFamilyPlusSans,
    color: '#2E2E2E',
    outline: 'none',
    cursor: 'text',
    '&::placeholder': {
      color: mixins.greyScaleColor,
      opacity: 1
    },
    '&:focus': {
      borderColor: mixins.amethystColorV2
    }
  },
  inputIcon: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 18,
    color: mixins.color_text_primary,
    pointerEvents: 'none'
  },
  calendarWrapper: {
    width: '100%',
    '& .react-datepicker__input-container': {
      display: 'none'
    },
    '& .react-datepicker-wrapper': {
      width: '100%'
    },
    ...getAssignmentDueDateCalendarStyles({ withShadow: false })
  },
  customHeader: calendarHeaderStyles.customHeader,
  navGroup: calendarHeaderStyles.navGroup,
  navButton: calendarHeaderStyles.navButton,
  monthYearLabel: calendarHeaderStyles.monthYearLabel
};

export const classes = createScopedClasses('aet-assignment-due-date-field', assignmentDueDateFieldStyles);

export const scopedStyles = createScopedStyles(assignmentDueDateFieldStyles, classes);

export const AssignmentDueDateFieldStylesRoot = styled('div')(scopedStyles);

export default assignmentDueDateFieldStyles;
